import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { AppState } from 'src/app/app.state';
import { isFunction } from 'src/app/shared/utilities/types.utils';
import { closeNotificationAction, removeNotificationAction } from './notification.actions';
import { selectNotifications } from './notification.selectors';
import { Notification, NotificationState } from './notification.state';

@Injectable({
	providedIn: 'root',
})
export class NotificationEffects {
	currentNotification: Notification;

	/**
	 * Handles routing to a different state.
	 */
	closeNotification$ = createEffect(() =>
		this.actions$.pipe(
			ofType(closeNotificationAction),
			map((action) => {
				const { onClose } = this.currentNotification;
				if (isFunction(onClose)) {
					onClose(action.clicked, action.data);
				}
				return removeNotificationAction();
			})
		)
	);

	/**
	 * Our effects constructor
	 * @param actions$ The action stream
	 * @param store The global store
	 */
	constructor(private actions$: Actions, store: Store<AppState>) {
		store.pipe(select(selectNotifications)).subscribe((state: NotificationState) => {
			this.currentNotification = state.current;
		});
	}
}
